<div class="relative" [style]="userDisplay.getGradientStyle()">
	<p-menubar [model]="[]">
		<ng-template #start>
			<img ngSrc="/images/logo_round_small.png" alt="Somerville Logo" height="40" width="40" />
		</ng-template>
		<ng-template #end>
			<div class="flex items-center gap-2">
				<p-tieredmenu #userMenu breakpoint="7680px" [model]="userMenuItems" [popup]="true"></p-tieredmenu>
				<button
					type="button"
					class="flex items-center gap-2 rounded-md border-none bg-transparent px-2 py-1 text-sm hover:bg-gray-100"
					[attr.aria-label]="userDisplay.getUserDisplayName()"
					(click)="userMenu.toggle($event)"
				>
					<p-avatar
						shape="circle"
						class="h-7! w-7! text-xs!"
						[label]="userDisplay.getUserInitial()"
						[style]="userDisplay.getAvatarStyle()"
					></p-avatar>
					<div class="flex flex-col items-start leading-tight">
						<span class="text-[1rem]! font-medium">{{ userDisplay.getUserDisplayName() }}</span>
						<span class="text-[0.7rem] font-bold tracking-wide" [style.color]="userDisplay.getAvatarColor()">{{
							userDisplay.getRoleDisplayText()
						}}</span>
					</div>
					<i class="pi pi-chevron-down ml-2 h-1! text-[0.55rem]! font-semibold! text-gray-400"></i>
				</button>
			</div>
		</ng-template>
	</p-menubar>
	<h1
		class="pointer-events-none absolute inset-0 flex items-center justify-center text-lg font-medium tracking-tight text-neutral-700 lg:text-xl"
	>
		Support Request
	</h1>
</div>
